import * as React  from "react";

const VideocallEnableCheckAlert = (props) => {
  return (
    <div className="alert alert-danger alert-dismissible" role="alert">
      <button type="button"
            className="close"
            data-dismiss="alert"
            aria-label="閉じる"><span aria-hidden="true">×</span></button>
      {props.message}
    </div>
  )
}

export default VideocallEnableCheckAlert

